import { DateTime } from 'luxon'

import SATTestQ from '@/queries/SATTestQ'
import type { Query } from '@/client/query'
import type { ProgramIteration, ProgramOfferingInstance } from '@/client/services/programs/types'
import {
  SAT_BOOTCAMP_MATH_OFFERING_TEMPLATE,
  SAT_BOOTCAMP_MATH_SERIES_TEMPLATE_SLUG,
  SAT_BOOTCAMP_READING_SERIES_TEMPLATE_SLUG,
  SAT_BOOTCAMP_READING_WRITING_OFFERING_TEMPLATE,
} from '@/client/services/satBootcamp/constants'

export default function satTestToProgramIteration(satTest: Query): ProgramIteration {
  const offerings: ProgramOfferingInstance[] = [
    {
      offeringTemplate: SAT_BOOTCAMP_MATH_OFFERING_TEMPLATE,
      startDate: DateTime.fromISO(`${satTest(SATTestQ.series_start_date_min)}`),
      endDate: DateTime.fromISO(`${satTest(SATTestQ.series_start_date_min)}`),
      seriesTemplateSlug: SAT_BOOTCAMP_MATH_SERIES_TEMPLATE_SLUG,
      programIterationId: satTest(SATTestQ.id) ?? 0,
    },
    {
      offeringTemplate: SAT_BOOTCAMP_READING_WRITING_OFFERING_TEMPLATE,
      startDate: DateTime.fromISO(`${satTest(SATTestQ.series_start_date_min)}`),
      endDate: DateTime.fromISO(`${satTest(SATTestQ.series_start_date_min)}`),
      seriesTemplateSlug: SAT_BOOTCAMP_READING_SERIES_TEMPLATE_SLUG,
      programIterationId: satTest(SATTestQ.id) ?? 0,
    },
  ]

  return {
    id: satTest(SATTestQ.id) ?? 0,
    title: satTest(SATTestQ.title) ?? '',
    iterationSlug: `sat-test-${satTest(SATTestQ.id)}`, // This doesn't get used for SAT, but is required for all other programs
    learnerRegistrationOpens: DateTime.fromISO(`${satTest(SATTestQ.learner_released_at)}`),
    learnerRegistrationDeadline: DateTime.fromISO(
      `${satTest(SATTestQ.learner_registration_deadline)}`
    ),
    tutorRegistrationDeadline: DateTime.fromISO(`${satTest(SATTestQ.series_creation_deadline)}`),
    tutorRegistrationOpens: DateTime.fromISO(`${satTest(SATTestQ.tutor_released_at)}`),
    startDate: DateTime.fromISO(`${satTest(SATTestQ.series_start_date_min)}`),
    endDate: DateTime.fromISO(`${satTest(SATTestQ.series_end_date_max)}`),
    offerings,
    recommendedHostingRatios: [],
    tutorPreSeriesSurveyUrl: undefined,
    tutorPostSeriesSurveyUrl: undefined,
    learnerPreSeriesSurveyUrl: undefined,
    learnerPostSeriesSurveyUrl: undefined,
    onboardingSessionDeadline: DateTime.fromISO(`${satTest(SATTestQ.onboarding_session_deadline)}`),
    onboardingSessionReleasedAt: DateTime.fromISO(
      `${satTest(SATTestQ.onboarding_session_released_at)}`
    ),
  }
}
